// ------------------------------Auth-----------
export const LOGIN_WITH_GOOGLE = "/api/user/socialLogin";

// ------------------------------Dashboard Models-----------
export const ADD_NEW_MODEL = "/api/user/addNewModel";
export const GENERATE_MODEL_IMAGE = "/api/user/createImage";
export const GET_MY_MODEL = "/api/user/getMyModels";
export const GET_MY_MODEL_DETAILS = "/api/user/getModelDetails";
export const GET_MY_MODEL_ANALYTICS = "/api/user/getModelDetails";

// ------------------------------Custom Image/Video-----------

export const UPLOAD_IMAGE = "/api/user/uploadImage";
export const GRNRTATE_CUSTOM_MEDIA = "/api/user/generateMedia";

// ------------------------------User Profile-----------------
export const GET_USER_PROFILE = "/api/user/myProfile";

// ------------------------------Gallery-----------------
export const GET_GALLERY = "/api/user/myGallery";
export const GET_GALLERY_BY_ID = "/api/user/getModelMedia";
export const DELETE_MEDIA = "/api/user/delmedia";

// ------------------------------Instagram-----------------
export const CONNECT_INSTAGRAM = "/api/user/connectInstagramAccount";
export const CREATE_INSRAGRAM_POST = "/api/user/createPost";
export const CREATE_INSRAGRAM_STORY = "/api/user/createInstagramStory";
export const UPDATE_INSRAGRAM_POST = "/api/user/updatePost";
export const GET_INSRAGRAM_POST = "/api/user/getPosts";
export const GET_INSRAGRAM_POST_DETAILS = "/api/user/getPostDetails";
export const DELETE_INSRAGRAM_POST = "/api/user/delPost";

// ------------------------------X-(twitter)-----------------
export const CONNECT_X = "/api/user/connectXAccount";
export const CREATE_X_POST = "/api/user/createXPost";
export const GET_X_POST = "/api/user/getXPosts";
export const GET_X_AUTH_URL = "/api/user/getXAuthUrl";
export const GET_X_AUTH_TOKEN = "/api/user/getXAuthToken";

// ------------------------------YouTube-----------------
export const GET_YOUTUBE_AUTH_URL = "/api/user/getYouTubeAuthUrl";
export const GET_YOUTUBE_AUTH_TOKEN = "/api/user/getYoutubeAuthToken";
export const CONNECT_YOUTUBE = "/api/user/connectYouTubeAccount";
export const CREATE_YOUTUBE_POST = "/api/user/createYouTubePost";
export const GET_YOUTUBE_POST = "/api/user/getYouTubePosts";
export const DELETE_YOUTUBE_POST = "/api/user/delYouTubePost";

// ------------------------------Tiktok-----------------
export const GET_TIKTOK_AUTH_URL = "/api/user/getTikTokAuthUrl";
export const GET_TIKTOK_AUTH_TOKEN = "/api/user/getTikTokAuthToken";
export const CONNECT_TIKTOK = "/api/user/connectTikTokAccount";
export const CREATE_TIKTOK_POST = "/api/user/createTiktokPost";
export const GET_TIKTOK_POST = "/api/user/getTiktokPosts";

// ------------------------------Facebook-----------------
export const CONNECT_FACEBOOK = "/api/user/connectInstagramAccount";
export const UPDATE_FACEBOOK_POST = "";
export const CREATE_FACEBOOK_POST = "/api/user/createFbPost";
export const GET_FACEBOOK_POST = "/api/user/getFbPosts";
export const GET_FACEBOOK_POST_DETAILS = "";
export const DELETE_FACEBOOK_POST = "/api/user/delFbPost";

// ------------------------------Persona-----------------
export const CREATE_PERSONA = "/api/user/createPersona";
export const GET_PERSONA = "/api/user/getMyPersonas";
export const EDIT_PERSONA = "/api/user/updatePersona";
export const DELETE_PERSONA = "/api/user/delPersona";

// ------------------------------Persona-----------------
export const AUTO_GENERATED_MEDIA = "/api/user/getAutoGeneratedMedia";